import UserSignup from '@/components/UserPanel/Signup';

export default function UserSignupPage() {
  return <UserSignup />;
}


export { getServerSideProps } from '@/lib/panelSsr';
